<template>
  <vx-card :title="$t('labels.document_details')" v-if="documentCount">
    <div class="port-listing">
      <div class="lead-listing">
        <div class="vx-row w-full mt-4 m-0 list-header">
          <div
            class="vx-col sm: w-1/2 md:w-1/2 mb-4 set_limit pl-0 pr-0 justify-between"
          >
            <div class="set flex">
              <label class="limit_label">{{ $t("labels.show") }}</label>
              <v-select
                v-model="limit"
                :options="limitarr"
                :reduce="(limitarr) => limitarr.value"
                :clearable="false"
                label="text"
                class="px-1"
              />
              <label class="limit_label">{{
                $t("labels.document_details")
              }}</label>
            </div>
          </div>
        </div>
      </div>
      <vs-table :data="documents">
        <template slot="thead">
          <vs-th>{{ $t("labels.document_type") }}</vs-th>
          <vs-th>{{ $t("labels.issuing_country") }}</vs-th>
          <vs-th>{{ $t("labels.name") }}</vs-th>
          <vs-th>{{ $t("labels.issuing_authority") }}</vs-th>
          <vs-th>{{ $t("labels.number") }}</vs-th>
          <vs-th>{{ $t("labels.issue_date") }}</vs-th>
          <vs-th>{{ $t("labels.expiry_date") }}</vs-th>
          <vs-th>{{ $t("labels.document_url") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ tr.document_name }}</vs-td>
            <vs-td v-if="tr.issuing_country_name">{{
              tr.issuing_country_name
            }}</vs-td>
            <vs-td v-else-if="!tr.issuing_country_name"> - </vs-td>
            <vs-td>{{ tr.name }}</vs-td>
            <vs-td v-if="tr.issuing_authority">{{
              tr.issuing_authority
            }}</vs-td>
            <vs-td v-else-if="!tr.issuing_authority"> - </vs-td>
            <vs-td v-if="tr.number">{{ tr.number }}</vs-td>
            <vs-td v-else-if="!tr.number"> - </vs-td>
            <vs-td v-if="tr.issue_date">{{
              tr.issue_date | only_date_format
            }}</vs-td>
            <vs-td v-else-if="!tr.issue_date"> - </vs-td>
            <vs-td v-if="tr.expiry_date">{{
              tr.expiry_date | only_date_format
            }}</vs-td>
            <vs-td v-else-if="!tr.expiry_date">-</vs-td>
            <vs-td>
              <div class="doc-img">
                <a
                  :href="tr.document_url"
                  target="_blank"
                  v-if="tr.docType === 'image'"
                >
                  <img :src="tr.document_url" alt="Image" />
                </a>
                <a
                  :href="tr.document_url"
                  target="_blank"
                  v-else-if="tr.docType === 'word'"
                  class="file"
                >
                  <img src="./../../assets/images/pages/doc.svg" alt="Logo" />
                </a>
                <a
                  :href="tr.document_url"
                  target="_blank"
                  v-else-if="tr.docType === 'music'"
                  class="file"
                >
                  <img
                    src="./../../assets/images/pages/music-file.svg"
                    alt="Logo"
                  />
                </a>
                <a
                  :href="tr.document_url"
                  target="_blank"
                  v-else-if="tr.docType === 'pdf'"
                  class="file"
                >
                  <img src="./../../assets/images/pages/pdf.svg" alt="Logo" />
                </a>
                <a
                  :href="tr.document_url"
                  target="_blank"
                  v-else-if="tr.docType === 'csv'"
                  class="file"
                >
                  <img src="./../../assets/images/pages/csv.svg" alt="Logo" />
                </a>
                <a :href="tr.document_url" target="_blank" v-else class="file">
                  <img src="./../../assets/images/pages/txt.svg" alt="Logo" />
                </a>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="mt-6">
        <vs-pagination
          color="dark"
          :total="totalPage"
          v-model="currentx"
          class="mb-1"
        ></vs-pagination>
      </div>
    </div>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      documentCount: 0,
      documentIds: [],
      ports: [],
      documents: "",
      index: -1,
      totalPage: 1,
      country: 0,
      filterCountries: [],
      currentx: 1,
      // limit: parseInt(process.env.VUE_APP_PER_PAGE),
      limit: this.$store.state.limit,
      showfilter: false,
      search: null,
      documentType: null,
      filterdocumentType: [
        { label: "Passport", value: "P" },
        { label: "Seamen book", value: "SB" },
        { label: "Visa", value: "V" },
        { label: "Other Documents", value: "O" },
      ],
    };
  },
  mounted() {
    if (localStorage.getItem("limit")) {
      this.limit = localStorage.getItem("limit");
    }
    this.getDocuments();
    this.$store.commit("UPDATE_TAB", 2);
  },
  watch: {
    limit(val) {
      localStorage.setItem("limit", val);
      this.currentx = 1;
      this.getDocuments();
    },
    currentx(val) {
      this.getDocuments();
    },
  },
  methods: {
    async getDocuments(exp = false) {
      let input = {
        page: this.currentx,
        perPage: this.limit,
        search: this.search,
        document_type: this.documentType,
      };
      if (exp) {
        input = Object.assign(
          {
            export: true,
          },
          input
        );
      }
      if (this.$store.state.userInfo.type === "A") {
        input = Object.assign(
          {
            user_id: this.$route.params.id,
          },
          input
        );
      }
      let response = await this.getHTTPPostResponse(
        "/consultants/list-documents",
        input
      );
      if (!exp) {
        if (response) {
          let data = response.data.documents;
          let perPage = 5;
          let totalPage = Math.ceil(response.data.count / perPage);
          this.totalPage = totalPage;
          this.documentCount = response.data.count;
          var docType = "";
          var documents = data;
          documents.forEach((doc) => {
            var extension = doc.document_url.split(".").pop();
            if (["png", "jpeg", "jpg", "gif"].includes(extension)) {
              docType = "image";
              doc.docType = docType;
            }
            if (["doc", "docx"].includes(extension)) {
              docType = "word";
              doc.docType = docType;
            }
            if (["mp3", "wav"].includes(extension)) {
              docType = "music";
              doc.docType = docType;
            }
            if (["pdf"].includes(extension)) {
              docType = "pdf";
              doc.docType = docType;
            }
            if (["csv"].includes(extension)) {
              docType = "csv";
              doc.docType = docType;
            }
          });
          this.documents = data;
        }
      }
    },
  },
};
</script>
<style scoped>
.doc-img img {
  height: 55px !important;
  border-radius: 3px;
  width: 70px !important;
  /* transition: transform 0.2s; */
}

/* .doc-img img:hover {
  height: 50px !important;
  transform: scale(2.5);
} */
</style>
